// Contexto para armazenar o ID da filial ativa (alimentado pelo Auth/JWT)

import React, { createContext, useState } from "react";

export const FilialIdContext = createContext()

export const FilialContextProvider = ({ children }) => {
    // Sem hardcode: valor vem do Auth via SyncAuthContexts
    const [filialIdContext, setFilialIdContext] = useState('')

    return (
        <FilialIdContext.Provider value={{ filialIdContext, setFilialIdContext }}>
            {children}
        </FilialIdContext.Provider>
    )
}
